﻿import { ChargeStatus } from '@nkr/enums/index';
import { IDonor } from './donor';
import { IRecipient } from './recipient';

export interface IBillableNephrectomy {
    id: number,

    donor: IDonor,
    recipient: IRecipient,

    transplantDate: string,
    surgeryDate: string,

    chainId: number,
    clusterNumber: number,
    positionNumber: number,

    physicianCharges: number,
    physicianChargeStatusId: ChargeStatus,
    physicianChargeStatus: string
    physicianChargeComments: string,
    physicianChargesUploadDate: string,
    physicianChargesUploadPath: string,

    anesthesiaCharges: number,
    anesthesiaChargeStatusId: ChargeStatus,
    anesthesiaChargeStatus: string,
    anesthesiaChargeComments: string,
    anesthesiaChargesUploadDate: string,
    anesthesiaChargesUploadPath: string,

    hospitalCharges: number,
    hospitalChargeStatusId: ChargeStatus,
    hospitalChargeStatus: string,
    hospitalChargeComments: string,
    hospitalChargesUploadDate: string,
    hospitalChargesUploadPath: string,

    statusId: number,
    statusDescription: string,
    statusAbbreviation: string,

    dateStartedByDonorCenter: string,

    dateSubmittedToRecipientCenter: string,
    submittedBy: string,

    dateDisputedByRecipientCenter: string,
    disputedById: number,
    disputedByName: string,

    dateAcceptedByRecipientCenter: string,
    acceptedBy: string,

    datePaymentReceivedFromRecipientCenter: string,
    recipientCenterPaymentACHConfirmation: string,
    paymentReceivedBy: string,

    datePaymentSentToDonorCenter: string,
    paymentSentBy: string,

    asaUnitCount: number,

    claimType: string,

    paymentDueDate: string,

    invoiceId: number,
    invoiceMonth: number,
    invoiceYear: number,
    invoiceNumber: number,
    invoicePaid: boolean,

    invoiceTotal: number,
    invoiceOpenAmount: number,
    invoicePayments: number,
    invoiceCredits: number,

    aging30To60:number,
    agingOver60:number,

    comments: string
}
